<template>
  <section class="video-section" aria-label="Video Sportemocracy">
    <video
      class="video-player"
      src="/images/SPORTEMOCRACY_VIDEO.mp4"
      poster="/images/poster_video.jpg"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
    />
  </section>
</template>

<script>
export default {
  name: 'VideoSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";
.video-section {
  width: 100%;
  overflow: hidden;
  line-height: 0;
  background: $primary;
}

.video-player {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
}

@media (min-width: 768px) {
  .video-section {
    height: 550px;
  }

  .video-player {
    height: 550px;
    aspect-ratio: 1440 / 550;
  }
}
</style>
